import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export type IngestCommitAction = 'approve' | 'reject';

/** A 409 means someone else has already approved or rejected the event. */
export const INGEST_CONFLICT_ERROR = 'This sync has already been approved or rejected.';

export interface ICommitIngestArgs {
  eventId: string;
  action: IngestCommitAction;
}

export const commitIngest = async ({ eventId, action }: ICommitIngestArgs): Promise<void> => {
  const res = await fetch(`${API_URL}/ingest/commit`, {
    method: 'POST',
    body: JSON.stringify({ eventId, action }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (res.status === Status.CONFLICT) throw new Error(INGEST_CONFLICT_ERROR);
  if (!res.ok) throw new Error(`Could not ${action} sync: ${res.status}`);
};
